// The chat bar's options, from the script tag's data-* attributes (see README.md).

function cssLength(v) {
  if (!v) return '';
  const s = String(v).trim();
  return /^\d+(\.\d+)?$/.test(s) ? `${s}px` : /^\d+(\.\d+)?(px|rem|em|vw|vh)$/.test(s) ? s : '';
}

/** Options from the script tag's data-* attributes. */
export function readConfig(script, here = location) {
  const d = script?.dataset ?? {};
  const src = script?.src ? new URL(script.src, here.href) : null;
  const flag = (v, dflt) => (v === undefined ? dflt : v === '' || /^(1|true|on|yes)$/i.test(v));
  return {
    base: src ? new URL('.', src).href : `${here.origin}/`, // where the chunks are (next to agent.js)
    site: d.site || '',
    side: d.side === 'left' ? 'left' : 'right',
    theme: d.theme === 'light' || d.theme === 'dark' ? d.theme : 'auto',
    open: flag(d.open, false),
    // defaults for the visitor's settings (they can change them)
    model: /^[\w.:-]{1,80}$/.test(d.model ?? '') ? d.model : '',
    reasoningEffort: ['none', 'minimal', 'low', 'medium', 'high'].includes(d.reasoning) ? d.reasoning : '',
    maxSteps: Math.max(0, Math.min(100, parseInt(d.maxSteps, 10) || 0)),
    screenshots: flag(d.screenshots, false),
    hotkey: d.hotkey === undefined ? 'ctrl+shift+y' : /^(off|none|false)$/i.test(d.hotkey) ? '' : d.hotkey,
    accent: /^#[0-9a-f]{3,8}$/i.test(d.accent ?? '') ? d.accent : '',
    width: parseInt(d.width, 10) || 0,
    offsetX: cssLength(d.offsetX),
    offsetY: cssLength(d.offsetY),
  };
}
